// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1H5Ts","author":"Table_author__27vQx","authorImage":"Table_authorImage__26NkK","unreadRow":"Table_unreadRow__1X1rH"};